import { Trans } from '@lingui/macro'
import ViewQuilt from '@material-ui/icons/ViewQuiltOutlined'
import { styles } from 'helpers'
import React from 'react'
import { FlexAlignItemsCenter, Grid, Paper, Typography } from 'webbook-airways'

export default function DashboardHeadline({
  title = <Trans>Dashboard</Trans>,
  subtitle = <Trans>Here's your overview</Trans>
}) {
  return (
    <Grid type="container" containerStyle={{ paddingBottom: 0 }}>
      <Grid type="all">
        <Paper>
          <FlexAlignItemsCenter>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 48,
                width: 48,
                borderRadius: '50%',
                backgroundColor: styles.colors.secondary
              }}
            >
              <ViewQuilt style={{ fontSize: 32, color: 'white' }} />
            </div>
            <div style={{ marginLeft: 15 }}>
              <Typography
                variant="h5"
                style={{ fontWeight: 500, marginBottom: -2 }}
              >
                {title}
              </Typography>
              <Typography style={{ color: '#888' }}>{subtitle}</Typography>
            </div>
          </FlexAlignItemsCenter>
        </Paper>
      </Grid>
    </Grid>
  )
}
